<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <div class="page-wrapper">
      <!-- Page Content -->
      <div class="content container-fluid">
        <div class="row">
          <div class="col-md-12">
            <!-- Page Header -->
            <singlebreadcrumb :title="title" />
            <!-- /Page Header -->

            <!-- Filters Section -->
            <div v-if="!loading" class="filter-section">
              <div class="row filter-row">
                <div class="col-sm-6 col-md-3">
                  <div class="h-100 mb-3">
                    <vue-select
                      :options="employee_list2"
                      id="hierarchy-employee"
                      v-model="filters.employeeName"
                      placeholder="Select Employee"
                      @update:modelValue="handleEmployeeUpdate"
                    />
                  </div>
                </div>
                <div class="col-sm-6 col-md-2">
                  <div class="h-100 mb-3">
                    <a-select
                      v-model:value="filters.designation"
                      show-search
                      placeholder="Select a Position"
                      style="width: 100%"
                      :options="optionsEmpDesignation"
                      @change="handleDesignationChange"
                    >
                    </a-select>
                  </div>
                </div>
                <div class="col-sm-6 col-md-2">
                  <div class="h-100 mb-3">
                    <a-select
                      v-model:value="filters.department"
                      show-search
                      placeholder="Select a Department"
                      style="width: 100%"
                      :options="optionsEmpDept"
                      @change="handleDepartmentChange"
                    >
                    </a-select>
                  </div>
                </div>
                <div class="col-sm-6 col-md-2">
                  <a
                    href="javascript:;"
                    class="btn btn-success w-100 submit-btn mb-3"
                    @click="applyFilters"
                  >
                    Search
                  </a>
                </div>
                <div class="col-sm-6 col-md-2">
                  <a
                    href="javascript:;"
                    class="btn btn-danger w-100 submit-btn"
                    @click="clearFilters"
                  >
                    Clear
                  </a>
                </div>
              </div>
            </div>

            <div v-if="loading" class="text-center p-4">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>

            <div
              v-else-if="filteredChartData"
              ref="orgChartContainer"
              class="hierarchy-container"
            >
              <OrganizationChart
                ref="orgChart"
                :value="filteredChartData"
                class="p-organizationchart"
              >
                <template #default="slotProps">
                  <div
                    class="org-node-content"
                    :data-node-key="slotProps.node._nodeKey"
                    @click="showUserDetails(slotProps.node)"
                  >
                    <div class="org-node-header">
                      <div class="org-node-avatar-wrapper">
                        <div class="org-node-avatar">
                          <img
                            v-if="getAvatarUrl(slotProps.node)"
                            :src="getAvatarUrl(slotProps.node)"
                            :alt="getDisplayName(slotProps.node)"
                            @error="handleImageError"
                            class="avatar-img"
                          />
                          <img
                            v-else
                            :src="defaultAvatarImg"
                            :alt="getDisplayName(slotProps.node)"
                            class="avatar-img"
                          />
                        </div>
                      </div>
                      <div class="org-node-name">
                        {{ getDisplayName(slotProps.node) }}
                      </div>
                    </div>
                    <div class="org-node-body">
                      <div class="org-node-info">
                        <div
                          v-if="getDesignation(slotProps.node)"
                          class="org-node-designation"
                        >
                          <i class="fas fa-briefcase"></i>
                          <span>{{ getDesignation(slotProps.node) }}</span>
                        </div>
                        <div
                          v-if="getDepartment(slotProps.node)"
                          class="org-node-department"
                        >
                          <i class="fas fa-building"></i>
                          <span>{{ getDepartment(slotProps.node) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </OrganizationChart>
              <svg
                ref="connectorOverlay"
                class="orgchart-connector-overlay"
              ></svg>
            </div>

            <div v-else class="text-center p-4">
              <p>No hierarchy data available</p>
            </div>

            <!-- User Details Modal -->
            <div
              id="user_details_modal"
              class="modal custom-modal fade"
              role="dialog"
              ref="userDetailsModal"
            >
              <div
                class="modal-dialog modal-dialog-centered user-details-modal-dialog"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header" style="justify-content: left">
                    <p
                      style="font-size: 30px; font-weight: 600; color: #1a1a1a"
                    >
                      Details
                    </p>
                    <button
                      type="button"
                      class="btn-close"
                      aria-label="Close"
                      @click="closeUserDetailsModal"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div
                    class="modal-body"
                    v-if="selectedUser"
                    style="padding-top: 0px"
                  >
                    <div class="user-details-content">
                      <div class="user-details-left">
                        <div class="user-details-avatar">
                          <img
                            v-if="getAvatarUrl(selectedUser)"
                            :src="getAvatarUrl(selectedUser)"
                            :alt="getDisplayName(selectedUser)"
                            @error="handleImageError"
                            class="details-avatar-img"
                          />
                          <img
                            v-else
                            :src="defaultAvatarImg"
                            :alt="getDisplayName(selectedUser)"
                            class="details-avatar-img"
                          />
                        </div>
                      </div>
                      <div class="user-details-right">
                        <div class="user-details-name">
                          <h3>{{ getDisplayName(selectedUser) }}</h3>
                        </div>
                        <div class="user-details-info">
                          <div
                            class="detail-item"
                            v-if="getUserEmail(selectedUser)"
                          >
                            <div class="detail-label">
                              <i class="fas fa-envelope"></i>
                              <span>Work Mail : </span>
                            </div>
                            <div class="detail-value">
                              {{ getUserEmail(selectedUser) }}
                            </div>
                          </div>
                          <div
                            class="detail-item"
                            v-if="getDesignation(selectedUser)"
                          >
                            <div class="detail-label">
                              <i class="fas fa-briefcase"></i>
                              <span>Position : </span>
                            </div>
                            <div class="detail-value">
                              {{ getDesignation(selectedUser) }}
                            </div>
                          </div>
                          <div
                            class="detail-item"
                            v-if="getReportingTo(selectedUser)"
                          >
                            <div class="detail-label">
                              <i class="fas fa-user-tie"></i>
                              <span>Reporting To : </span>
                            </div>
                            <div class="detail-value">
                              {{ getReportingTo(selectedUser) }}
                            </div>
                          </div>
                          <div class="detail-item">
                            <div class="detail-label">
                              <i class="fas fa-users"></i>
                              <span>Employees Reporting : </span>
                            </div>
                            <div class="detail-value">
                              {{ getChildrenCount(selectedUser) }}
                            </div>
                          </div>
                          <div
                            class="detail-item"
                            v-if="getDepartment(selectedUser)"
                          >
                            <div class="detail-label">
                              <i class="fas fa-building"></i>
                              <span>Department : </span>
                            </div>
                            <div class="detail-value">
                              {{ getDepartment(selectedUser) }}
                            </div>
                          </div>
                          <div
                            class="detail-item"
                            v-if="getUserPhone(selectedUser)"
                          >
                            <div class="detail-label">
                              <i class="fas fa-phone"></i>
                              <span>Phone : </span>
                            </div>
                            <div class="detail-value">
                              {{ getUserPhone(selectedUser) }}
                            </div>
                          </div>
                          <div
                            class="detail-item"
                            v-if="getProjects(selectedUser)"
                          >
                            <div class="detail-label">
                              <i class="fas fa-building"></i>
                              <span>Projects : </span>
                            </div>
                            <div class="detail-value">
                              {{ getProjects(selectedUser) }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { notification } from "ant-design-vue";
import OrganizationChart from "primevue/organizationchart";
import * as bootstrap from "bootstrap";

export default {
  components: {
    OrganizationChart,
  },
  data() {
    return {
      title: "Organization Hierarchy",
      hierarchyData: [],
      chartData: null,
      filteredChartData: null,
      loading: false,
      defaultAvatarImg: require("@/assets/img/profiles/avatar-01.jpg"),
      nodeKeyCounter: 0,
      filters: {
        employeeName: null,
        designation: null,
        department: null,
      },
      employee_list2: [],
      optionsEmpDesignation: [],
      optionsEmpDept: [],
      selectedUser: null,
      userDetailsModal: null,
      connectorObserver: null,
      connectorUpdateHandle: null,
      connectorResizeHandler: null,
    };
  },
  watch: {
    filteredChartData() {
      this.$nextTick(() => {
        this.scheduleConnectorUpdate();
      });
    },
  },
  computed: {
    hasActiveFilters() {
      return (
        this.filters.employeeName !== null ||
        this.filters.designation !== null ||
        this.filters.department !== null
      );
    },
  },
  mounted() {
    this.loadHierarchy();
    this.loadAllEmployees();
    this.fetchDesignations();
    this.fetchDepartment();
    this.initModal();
    this.$nextTick(() => {
      this.setupConnectorObserver();
      this.scheduleConnectorUpdate();
    });
    this.connectorResizeHandler = () => {
      this.scheduleConnectorUpdate();
    };
    window.addEventListener("resize", this.connectorResizeHandler);
  },
  updated() {
    this.scheduleConnectorUpdate();
  },
  beforeUnmount() {
    if (this.userDetailsModal) {
      this.userDetailsModal.dispose();
    }
    const modalElement = this.$refs.userDetailsModal;
    if (modalElement) {
      modalElement.removeEventListener(
        "shown.bs.modal",
        this.scheduleConnectorUpdate,
      );
      modalElement.removeEventListener(
        "hidden.bs.modal",
        this.scheduleConnectorUpdate,
      );
    }
    if (this.connectorObserver) {
      this.connectorObserver.disconnect();
      this.connectorObserver = null;
    }
    if (this.connectorUpdateHandle) {
      cancelAnimationFrame(this.connectorUpdateHandle);
      this.connectorUpdateHandle = null;
    }
    if (this.connectorResizeHandler) {
      window.removeEventListener("resize", this.connectorResizeHandler);
      this.connectorResizeHandler = null;
    }
  },
  methods: {
    setupConnectorObserver() {
      const chartEl = this.$refs.orgChart && this.$refs.orgChart.$el;
      if (!chartEl || typeof MutationObserver === "undefined") {
        return;
      }

      if (this.connectorObserver) {
        this.connectorObserver.disconnect();
      }

      this.connectorObserver = new MutationObserver(() => {
        this.scheduleConnectorUpdate();
      });

      this.connectorObserver.observe(chartEl, {
        childList: true,
        subtree: true,
      });
    },
    scheduleConnectorUpdate() {
      if (this.connectorUpdateHandle) {
        return;
      }
      this.connectorUpdateHandle = requestAnimationFrame(() => {
        this.connectorUpdateHandle = null;
        this.updateConnectorLines();
      });
    },
    updateConnectorLines() {
      const chartEl = this.$refs.orgChart && this.$refs.orgChart.$el;
      const containerEl = this.$refs.orgChartContainer;
      const svgEl = this.$refs.connectorOverlay;

      if (!chartEl || !containerEl || !svgEl || !this.filteredChartData) {
        return;
      }

      const containerRect = containerEl.getBoundingClientRect();
      const width = Math.max(containerEl.scrollWidth, containerEl.clientWidth);
      const height = Math.max(
        containerEl.scrollHeight,
        containerEl.clientHeight,
      );

      svgEl.setAttribute("width", width);
      svgEl.setAttribute("height", height);
      svgEl.setAttribute("viewBox", `0 0 ${width} ${height}`);

      const getNodePosition = (nodeKey) => {
        const nodeEl = chartEl.querySelector(`[data-node-key="${nodeKey}"]`);
        if (!nodeEl) {
          return null;
        }
        const rect = nodeEl.getBoundingClientRect();
        return {
          x:
            rect.left -
            containerRect.left +
            rect.width / 2 +
            containerEl.scrollLeft,
          top: rect.top - containerRect.top + containerEl.scrollTop,
          bottom: rect.bottom - containerRect.top + containerEl.scrollTop,
        };
      };

      const segments = [];
      const addSegment = (x1, y1, x2, y2) => {
        segments.push({ x1, y1, x2, y2 });
      };
      const drawSegment = (x1, y1, x2, y2) => {
        const line = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "line",
        );
        line.setAttribute("x1", x1);
        line.setAttribute("y1", y1);
        line.setAttribute("x2", x2);
        line.setAttribute("y2", y2);
        line.setAttribute("stroke", "#3E32A3");
        line.setAttribute("stroke-width", "2");
        line.setAttribute("stroke-linecap", "round");
        svgEl.appendChild(line);
      };

      const walk = (node) => {
        if (!node || !node.children || node.children.length === 0) {
          return;
        }

        const parentPos = getNodePosition(node._nodeKey);
        if (!parentPos) {
          return;
        }

        const childPositions = node.children
          .map((child) => ({
            node: child,
            pos: getNodePosition(child._nodeKey),
          }))
          .filter((item) => item.pos);

        if (childPositions.length === 0) {
          return;
        }

        if (childPositions.length === 1) {
          const childPos = childPositions[0].pos;
          addSegment(parentPos.x, parentPos.bottom, childPos.x, childPos.top);
        } else {
          const minChildX = Math.min(
            ...childPositions.map((item) => item.pos.x),
          );
          const maxChildX = Math.max(
            ...childPositions.map((item) => item.pos.x),
          );
          const minChildTop = Math.min(
            ...childPositions.map((item) => item.pos.top),
          );
          const gap = minChildTop - parentPos.bottom;
          let lineY = parentPos.bottom + Math.max(8, gap / 2);
          lineY = Math.min(lineY, minChildTop - 4);

          addSegment(parentPos.x, parentPos.bottom, parentPos.x, lineY);
          addSegment(minChildX, lineY, maxChildX, lineY);
          childPositions.forEach((item) => {
            addSegment(item.pos.x, lineY, item.pos.x, item.pos.top);
          });
        }

        node.children.forEach((child) => walk(child));
      };

      walk(this.filteredChartData);

      if (segments.length === 0) {
        return;
      }

      while (svgEl.firstChild) {
        svgEl.removeChild(svgEl.firstChild);
      }

      segments.forEach((segment) => {
        drawSegment(segment.x1, segment.y1, segment.x2, segment.y2);
      });
    },
    loadHierarchy() {
      this.loading = true;
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/employees/org-hierarchy")
        .then((response) => {
          this.loading = false;
          loader.hide();

          let data = null;
          if (response.data && response.data.data) {
            // Handle different response structures
            if (Array.isArray(response.data.data)) {
              data = response.data.data;
            } else if (response.data.data.children) {
              data = [response.data.data];
            } else if (Array.isArray(response.data)) {
              data = response.data;
            }
          } else if (Array.isArray(response.data)) {
            data = response.data;
          }

          if (data && data.length > 0) {
            this.hierarchyData = data;
            // Transform data for PrimeVue org chart
            this.chartData = this.transformDataForChart(data);
            this.applyFilters();
          } else {
            this.chartData = null;
            this.filteredChartData = null;
          }
        })
        .catch((error) => {
          this.loading = false;
          loader.hide();

          var response = error.response;

          if (
            error.response &&
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message:
                response?.data?.message || "Error loading hierarchy data",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    transformDataForChart(data) {
      // Transform API data to PrimeVue OrganizationChart format
      // PrimeVue expects: { label, children: [...] }
      this.nodeKeyCounter = 0;
      const transformNode = (node) => {
        const transformed = {
          label: this.getDisplayNameFromNode(node),
          expanded: true,
          data: {
            name: this.getDisplayNameFromNode(node),
            designation: this.getDesignationFromNode(node),
            department: this.getDepartmentFromNode(node),
            avatar: this.getAvatarFromNode(node),
          },
          children: [],
          // Store original data for custom template
          _originalData: node,
          _nodeKey: this.nodeKeyCounter++,
        };

        if (
          node.children &&
          Array.isArray(node.children) &&
          node.children.length > 0
        ) {
          transformed.children = node.children.map((child) =>
            transformNode(child),
          );
        }

        return transformed;
      };

      // If data is an array, use first item as root, or combine them
      if (Array.isArray(data)) {
        if (data.length === 1) {
          return transformNode(data[0]);
        } else {
          // Multiple roots - create a virtual root
          return {
            label: "Organization",
            expanded: true,
            data: {
              name: "Organization",
              designation: "",
              department: "",
              avatar: null,
            },
            children: data.map((item) => transformNode(item)),
            _nodeKey: this.nodeKeyCounter++,
          };
        }
      }

      return transformNode(data);
    },
    getDisplayName(node) {
      const data = node._originalData || node.data || node;
      return this.getDisplayNameFromNode(data);
    },
    getDisplayNameFromNode(data) {
      return data.name || data.employee_name || data.full_name || "Unnamed";
    },
    getDesignation(node) {
      const data = node._originalData || node.data || node;
      return this.getDesignationFromNode(data);
    },
    getDesignationFromNode(data) {
      // Prioritize designation_name field
      if (data.designation_name) {
        return data.designation_name;
      }
      if (typeof data.designation === "string") {
        return data.designation;
      } else if (data.designation && typeof data.designation === "object") {
        return (
          data.designation.designation_name ||
          data.designation.name ||
          data.designation.designation ||
          null
        );
      }
      return null;
    },
    getDepartment(node) {
      const data = node._originalData || node.data || node;
      return this.getDepartmentFromNode(data);
    },
    getDepartmentFromNode(data) {
      // Prioritize department_name field
      if (data.department_name) {
        return data.department_name;
      }
      if (typeof data.department === "string") {
        return data.department;
      } else if (data.department && typeof data.department === "object") {
        return (
          data.department.department_name ||
          data.department.name ||
          data.department.department ||
          null
        );
      }
      return null;
    },
    getProjects(node) {
      const data = node._originalData || node.data || node;
      return this.getProjectsFromNode(data);
    },
    getProjectsFromNode(data) {
      // Prioritize projects field
      if (data.projects && Array.isArray(data.projects)) {
        return data.projects
          .map((project) => project.project_name || project.name)
          .join(", ");
      }
      return null;
    },
    getAvatarFromNode(data) {
      return data.avatar || data.profile_image || data.profile_picture || null;
    },
    getAvatarUrl(node) {
      const data = node._originalData || node.data || node;
      const avatar = this.getAvatarFromNode(data);
      if (avatar && avatar !== null && avatar !== "") {
        return `${process.env.VUE_APP_IMAGE_BASE_URL}${avatar}`;
      }
      return null;
    },
    handleImageError(event) {
      if (event.target) {
        event.target.src = this.defaultAvatarImg;
      }
    },
    applyFilters() {
      if (!this.chartData) {
        this.filteredChartData = null;
        return;
      }

      if (!this.hasActiveFilters) {
        this.filteredChartData = this.chartData;
        return;
      }

      // Filter the hierarchy data
      const filterNode = (node) => {
        // Check if current node matches filters
        const data = node._originalData || node.data || {};
        const name = this.getDisplayNameFromNode(data).toLowerCase();
        const designation = (
          this.getDesignationFromNode(data) || ""
        ).toLowerCase();
        const department = (
          this.getDepartmentFromNode(data) || ""
        ).toLowerCase();

        // Get employee name from selected employee object
        let employeeNameFilter = "";
        if (this.filters.employeeName) {
          if (
            typeof this.filters.employeeName === "object" &&
            this.filters.employeeName.text
          ) {
            employeeNameFilter = this.filters.employeeName.text.toLowerCase();
          } else if (typeof this.filters.employeeName === "string") {
            employeeNameFilter = this.filters.employeeName.toLowerCase();
          }
        }

        const matchesEmployeeName =
          !this.filters.employeeName || name.includes(employeeNameFilter);
        const matchesDesignation =
          !this.filters.designation ||
          designation === (this.filters.designation || "").toLowerCase() ||
          designation.includes((this.filters.designation || "").toLowerCase());
        const matchesDepartment =
          !this.filters.department ||
          department === (this.filters.department || "").toLowerCase() ||
          department.includes((this.filters.department || "").toLowerCase());

        const nodeMatches =
          matchesEmployeeName && matchesDesignation && matchesDepartment;

        // Filter children recursively
        let filteredChildren = [];
        if (node.children && node.children.length > 0) {
          filteredChildren = node.children
            .map((child) => filterNode(child))
            .filter((child) => child !== null);
        }

        // If node matches or has matching children, include it
        if (nodeMatches || filteredChildren.length > 0) {
          return {
            ...node,
            children: filteredChildren,
          };
        }

        return null;
      };

      const filtered = filterNode(this.chartData);
      this.filteredChartData = filtered;
    },
    clearFilters() {
      this.filters = {
        employeeName: null,
        designation: null,
        department: null,
      };
      this.applyFilters();
    },
    loadAllEmployees() {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .get("/employees/allemployees")
        .then((response) => {
          if (response.data && response.data.data) {
            this.employee_list2 = response.data.data.map((employee) => {
              return {
                id: employee.first_name,
                text:
                  `${employee.first_name || ""} ${
                    employee.last_name || ""
                  }`.trim() || "Unnamed",
              };
            });
          }
        })
        .catch((error) => {
          console.log("error during fetching employees", error);
        });
    },
    fetchDesignations() {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .get("designations/all")
        .then((response) => {
          const designations = response?.data?.data || [];

          if (designations) {
            this.optionsEmpDesignation = designations.map((designation) => {
              return {
                label: designation.name,
                value: designation.name, // Value same as name
              };
            });

            this.optionsEmpDesignation.unshift({ label: "All", value: null });
          }
        })
        .catch((error) => {
          console.log("error during fetching designation", error);
        });
    },
    fetchDepartment() {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      axios
        .get("/departments/all")
        .then((response) => {
          if (response?.data?.data && response?.data?.data?.length) {
            this.optionsEmpDept = [{ value: null, label: "All" }];

            for (let i = 0; i < response?.data?.data.length; i++) {
              this.optionsEmpDept.push({
                value: response.data.data[i].name, // Value same as name
                label: response.data.data[i].name,
              });
            }
          } else {
            this.optionsEmpDept = [{ value: null, label: "No Records" }];
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    handleEmployeeUpdate(value) {
      this.$nextTick(() => {
        this.filters.employeeName = value;
        this.applyFilters();
      });
    },
    handleDesignationChange(value) {
      this.$nextTick(() => {
        this.filters.designation = value;
        this.applyFilters();
      });
    },
    handleDepartmentChange(value) {
      this.$nextTick(() => {
        this.filters.department = value;
        this.applyFilters();
      });
    },
    initModal() {
      this.$nextTick(() => {
        const modalElement = this.$refs.userDetailsModal;
        if (modalElement) {
          this.userDetailsModal = new bootstrap.Modal(modalElement, {
            backdrop: true,
            keyboard: true,
          });
          modalElement.addEventListener(
            "shown.bs.modal",
            this.scheduleConnectorUpdate,
          );
          modalElement.addEventListener(
            "hidden.bs.modal",
            this.scheduleConnectorUpdate,
          );
        }
      });
    },
    showUserDetails(node) {
      this.selectedUser = node;
      this.$nextTick(() => {
        if (this.userDetailsModal) {
          this.userDetailsModal.show();
        } else {
          this.initModal();
          this.$nextTick(() => {
            if (this.userDetailsModal) {
              this.userDetailsModal.show();
            }
          });
        }
      });
    },
    closeUserDetailsModal() {
      if (this.userDetailsModal) {
        this.userDetailsModal.hide();
      }
      this.selectedUser = null;
    },
    getUserEmail(node) {
      const data = node._originalData || node.data || node;
      return data.email || data.employee_email || null;
    },
    getUserPhone(node) {
      const data = node._originalData || node.data || node;
      return data.phone || data.mobile || data.phone_number || null;
    },
    getReportingTo(node) {
      // Find parent node in the hierarchy tree
      const findParent = (currentNode, targetNode, parent = null) => {
        if (currentNode === targetNode) {
          return parent;
        }

        if (currentNode.children && Array.isArray(currentNode.children)) {
          for (let child of currentNode.children) {
            const result = findParent(child, targetNode, currentNode);
            if (result !== null) {
              return result;
            }
          }
        }

        return null;
      };

      if (!this.filteredChartData) {
        return null;
      }

      const parentNode = findParent(this.filteredChartData, node);
      if (parentNode && parentNode !== null) {
        // Check if it's the virtual root node
        if (
          parentNode.label === "Organization" &&
          parentNode.data &&
          parentNode.data.name === "Organization"
        ) {
          return null;
        }
        return this.getDisplayName(parentNode);
      }

      return null;
    },
    getChildrenCount(node) {
      if (node.children && Array.isArray(node.children)) {
        return node.children.length;
      }
      const data = node._originalData || node.data || node;
      if (data.children && Array.isArray(data.children)) {
        return data.children.length;
      }
      return 0;
    },
  },
};
</script>

<style scoped>
.hierarchy-container {
  margin-top: 15px;
  padding: 15px 10px;
  overflow-x: auto;
  overflow-y: visible;
  min-height: 300px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
  width: 100%;
  position: relative;
}

.orgchart-connector-overlay {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 1;
}

/* Filter Section Styles */
.filter-section {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.filter-row {
  margin: 0;
}

/* PrimeVue OrganizationChart Base Styles */
:deep(.p-organizationchart) {
  background: transparent;
  border: none;
  padding: 10px 5px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  min-width: fit-content;
}

:deep(.p-organizationchart-table) {
  border-collapse: separate;
  border-spacing: 6px 12px;
  margin: 0;
  width: auto;
}

:deep(.p-organizationchart-table > tbody > tr > td) {
  padding: 0;
  line-height: 0;
  min-height: 0;
  border: none;
  min-width: 0;
}

:deep(.p-organizationchart-connectors) {
  line-height: 0;
  height: auto;
}

/* Hide duplicate consecutive tr elements with p-organizationchart-connectors class */
:deep(tr.p-organizationchart-connectors + tr.p-organizationchart-connectors) {
  display: none !important;
}

:deep(.p-organizationchart-node-content) {
  border: none;
  padding: 0;
  background: transparent;
  text-align: center;
}

:deep(.p-organizationchart-node-content .p-node-toggler) {
  display: none;
}

/* Hide PrimeVue default connectors; custom SVG overlay renders lines */
:deep(.p-organizationchart-connector-down),
:deep(.p-organizationchart-connector-left),
:deep(.p-organizationchart-connector-right),
:deep(.p-organizationchart-connector-top) {
  visibility: hidden;
}

:deep(.p-organizationchart-node-box) {
  padding: 0;
  border: none;
  background: transparent;
  position: relative;
}

:deep(.p-organizationchart-node-cell) {
  padding: 0;
  vertical-align: top;
  position: relative;
}

.org-node-content {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 2px solid #e8e8e8;
  border-radius: 10px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.05);
  padding: 0;
  min-width: 200px;
  max-width: 280px;
  width: 100%;
  cursor: pointer;
  text-align: center;
  overflow: hidden;
  position: relative;
  transition: all 0.2s ease;
}

.org-node-content:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 8px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08);
  border-color: #3e32a3;
}

.org-node-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 10px 12px;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  gap: 10px;
}

.org-node-avatar-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  flex-shrink: 0;
}

.org-node-avatar {
  position: relative;
  display: inline-block;
}

.avatar-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  position: relative;
  z-index: 2;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15), 0 0 0 2px rgba(255, 155, 68, 0.1);
}

.org-node-body {
  padding: 12px 10px;
  background: #ffffff;
}

.org-node-info {
  text-align: center;
}

.org-node-name {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 0;
  word-wrap: break-word;
  line-height: 1.3;
  letter-spacing: -0.2px;
  flex: 1;
  text-align: left;
}

.org-node-designation,
.org-node-department {
  color: #495057;
  font-size: 12px;
  margin: 5px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  word-wrap: break-word;
  line-height: 1.4;
  padding: 5px 10px;
  background: #f8f9fa;
  border-radius: 5px;
  transition: all 0.2s ease;
}

.org-node-designation {
  background: linear-gradient(135deg, #fff5ec 0%, #ffe8d1 100%);
  border-left: 3px solid #3e32a3;
}

.org-node-department {
  background: linear-gradient(135deg, #edf7ee 0%, #d4e8d7 100%);
  border-left: 3px solid #825ef5;
}

.org-node-designation i {
  color: #3e32a3;
  font-size: 12px;
  flex-shrink: 0;
}

.org-node-department i {
  color: #825ef5;
  font-size: 12px;
  flex-shrink: 0;
}

.org-node-designation span,
.org-node-department span {
  font-weight: 500;
}

/* User Details Modal Styles */
.user-details-modal-dialog .modal-content {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.user-details-modal-dialog .modal-header {
  padding: 10px 15px;
  border-bottom: 1px solid #e8e8e8;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

.user-details-modal-dialog .modal-header .modal-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}

.user-details-modal-dialog .modal-body {
  padding: 0;
  max-height: 60vh;
  overflow-y: auto;
}

.user-details-modal-dialog .modal-body::-webkit-scrollbar {
  width: 6px;
}

.user-details-modal-dialog .modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.user-details-modal-dialog .modal-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.user-details-modal-dialog .modal-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.user-details-modal-dialog {
  max-width: 450px;
  width: 90%;
}

.user-details-content {
  /* padding: 15px; */
  display: flex;
  gap: 20px;
  align-items: anchor-center;
}

.user-details-left {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.user-details-avatar {
  flex-shrink: 0;
}

.details-avatar-img {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #3e32a3;
  box-shadow: 0 2px 8px rgba(62, 50, 163, 0.2);
}

.user-details-right {
  flex: 1;
  min-width: 0;
}

.user-details-name {
  margin-bottom: 12px;
}

.user-details-name h4 {
  margin: 0;
  color: #1a1a1a;
  font-weight: 700;
  font-size: 16px;
  word-wrap: break-word;
  line-height: 1.3;
}

.user-details-info {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

.detail-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  /* padding: 8px 10px; */
  background: #f8f9fa;
  border-radius: 6px;
  /* border-left: 3px solid #3E32A3; */
  transition: all 0.2s ease;
}

.detail-item:hover {
  background: #f0f0f0;
  border-left-color: #825ef5;
}

.detail-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #495057;
  font-size: 12px;
  text-transform: none;
  letter-spacing: 0;
  white-space: nowrap;
  flex-shrink: 0;
}

.detail-label i {
  color: #3e32a3;
  font-size: 14px;
  width: 16px;
  text-align: center;
  flex-shrink: 0;
}

.detail-value {
  color: #1a1a1a;
  font-size: 12px;
  word-wrap: break-word;
  font-weight: 500;
  line-height: 1.3;
  text-align: left;
  flex: 1;
  min-width: 0;
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

/* User Details Modal Responsive */
@media (max-width: 768px) {
  .user-details-modal-dialog {
    max-width: 95%;
  }

  .user-details-content {
    padding: 12px;
    flex-direction: column;
    align-items: center;
  }

  .user-details-left {
    width: 100%;
    justify-content: center;
  }

  .details-avatar-img {
    width: 60px;
    height: 60px;
  }

  .user-details-right {
    width: 100%;
  }

  .user-details-name {
    text-align: center;
    margin-bottom: 10px;
  }

  .user-details-name h4 {
    font-size: 15px;
  }

  .detail-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    padding: 8px 10px;
  }

  .detail-value {
    text-align: left;
    padding-left: 24px;
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .hierarchy-container {
    padding: 8px 5px;
  }

  .org-node-content {
    min-width: 100%;
    max-width: 100%;
  }

  :deep(.p-organizationchart-table) {
    border-spacing: 6px 12px;
  }
}

/* Ant Design Select Styles */
:deep(
    .ant-select-single:not(.ant-select-customize-input) .ant-select-selector
  ) {
  height: 50px !important;
}

:deep(.ant-select:not(.ant-select-customize-input) .ant-select-selector) {
  font-weight: 600;
}
</style>
